export const styles = {
    directoryIcon: {
        width: 20,
        height: 20
    }
}